import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlotInlineCheckboxComponent } from '../slot-inline-checkbox/slot-inline-checkbox.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DelayDisplayImpurePipe, SlotTooltipPipe, TranslationKeyPipe } from '../../../pipes';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LayoutDirective } from '../../../directives';
import { ComponentsModule } from '../../../../../lib';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-tile-checkbox',
    imports: [
        CommonModule,
        ComponentsModule,
        MatCheckboxModule,
        LayoutDirective,
        TranslationKeyPipe,
        SlotTooltipPipe,
        DelayDisplayImpurePipe,
        VisualComponent
    ],
    templateUrl: './slot-tile-checkbox.component.html',
    styleUrl: './slot-tile-checkbox.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotTileCheckboxComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotTileCheckboxComponent extends SlotInlineCheckboxComponent {}
